import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { APIContainer, LogTypes, sawinFunc } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as UserMdl from '../models/AdditionalUser';
//import { AdditionalUserListListLoadInfo } from './AdditionalUserListList';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.


export interface AdditionalUserListLoading { type: 'ADDITIONALUSERLIST_LOADING', loading: boolean }
export interface AdditionalUserListError { type: 'ADDITIONALUSERLIST_ERROR', error: string }
export interface AdditionalUserListLoadInfo { type: 'ADDITIONALUSERLIST_LOADINFO', data: UserMdl.AdditionalUserList }
export interface AdditionalUserListReset { type: 'ADDITIONALUSERLIST_RESET' }

export type KnownAction = AdditionalUserListLoading | AdditionalUserListError | AdditionalUserListLoadInfo | AdditionalUserListReset;

export const actionCreators = {
    retrieve: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;     

        const BillTo = sessionState.SelectedAR.id;
        const CompanyCode = sessionState.SelectedAR.companyCode;
        const ServiceMasterNum = sessionState.SelectedSM.id;


        dispatch({ type: 'ADDITIONALUSERLIST_LOADING', loading: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/AdditionalPhones?CompanyCode=${CompanyCode}&ServiceMasterNum=${ServiceMasterNum}&BillTo=${BillTo}`,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                //Do something with response                
                if (container.success) {
                    const data: UserMdl.AdditionalUser[] = container.data;
                    dispatch({ type: 'ADDITIONALUSERLIST_LOADINFO', data: { items: data, loading: false, error: '' } });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                    dispatch({
                        type: 'ADDITIONALUSERLIST_ERROR', error: container.errorInfo.message
                    })
                }

            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'ADDITIONALUSERLIST_ERROR', error: err.message
                })
            });
    },
    delete: (PhoneNumber: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;

        const BillTo = sessionState.SelectedAR.id;
        const CompanyCode = sessionState.SelectedAR.companyCode;
        const ServiceMasterNum = sessionState.SelectedSM.id;


        dispatch({ type: 'ADDITIONALUSERLIST_LOADING', loading: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/AdditionalPhones?CompanyCode=${CompanyCode}&ServiceMasterNum=${ServiceMasterNum}&BillTo=${BillTo}&PhoneNumber=${PhoneNumber}`,
            {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                //Do something with response                
                if (container.success) {
                    const data: UserMdl.AdditionalUser[] = container.data;
                    dispatch({ type: 'ADDITIONALUSERLIST_LOADINFO', data: { items: data, loading: false, error: '' } });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                    dispatch({
                        type: 'ADDITIONALUSERLIST_ERROR', error: container.errorInfo.message
                    })
                }

            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'ADDITIONALUSERLIST_ERROR', error: err.message
                })
            });
    },
    resetState: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: "ADDITIONALUSERLIST_RESET" });
    }
};

export const reducer: Reducer<UserMdl.AdditionalUserList> = (state: UserMdl.AdditionalUserList | undefined, incomingAction: Action): UserMdl.AdditionalUserList => {

    if (state === undefined) {
        return { ...UserMdl.initialListState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'ADDITIONALUSERLIST_LOADING':
            return { ...state, loading: (action as AdditionalUserListLoading).loading }
        case 'ADDITIONALUSERLIST_ERROR':
            return { ...state, loading: false, error: (action as AdditionalUserListError).error }
        case 'ADDITIONALUSERLIST_LOADINFO':
            return { ...state, ...(action as AdditionalUserListLoadInfo).data } 
        case 'ADDITIONALUSERLIST_RESET':
            return { ...state, ...UserMdl.initialListState }
        default:
            return state;
    }
}; 